import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { overlaysApi } from "../api/overlaysApi";
import type { ListOverlaysQuery, ModerateOverlayBody } from "../types";

export const overlayKeys = {
  all: ["overlays"] as const,
  list: (query?: ListOverlaysQuery) =>
    [...overlayKeys.all, "list", query ?? {}] as const,
  detail: (slug: string) => [...overlayKeys.all, "detail", slug] as const,
};

export const useOverlaysList = (query: ListOverlaysQuery) =>
  useQuery({
    queryKey: overlayKeys.list(query),
    queryFn: () => overlaysApi.listOverlays(query),
  });

export const useOverlayDetail = (slug: string | undefined) =>
  useQuery({
    queryKey: overlayKeys.detail(slug ?? ""),
    queryFn: () => overlaysApi.getOverlayBySlug(slug as string),
    enabled: !!slug,
  });

export const useModerateOverlay = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: ModerateOverlayBody }) =>
      overlaysApi.moderateOverlay(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: overlayKeys.all });
    },
  });
};
